import { render, staticRenderFns } from "./RankingClubs.vue?vue&type=template&id=2deb4d8f&"
import script from "./RankingClubs.vue?vue&type=script&lang=js&"
export * from "./RankingClubs.vue?vue&type=script&lang=js&"
import style0 from "./RankingClubs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports